import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../../store/index';
import { withStyles } from '@material-ui/core/styles';
import { Button, FormControl, Grid, Input, InputLabel, Paper, Select, TextField, Typography } from '@material-ui/core';
import classnames from 'classnames';
import SimpleTable from 'components/SimpleTable';
import ExpandableCell from 'components/SimpleTable/ExpandableCell';
import svc from 'svc';
import { memoize } from "lodash";



const styles = theme => ({
	gridRoot: {
		flexGrow: 1,
		width: '100%',
		margin: 16,
	},
	searchButton: {
		marginRight: 16,
	},
	searchTable: {
		minHeight: 600,
		marginTop: 30,
		marginRight: 32,
	},
	formField: {
		width: '100%',
	},
});

const searchCols = [
	{ name: 'ClgCode', title: 'Activity Number' },
	{ name: 'CardCode', title: 'BP Code' },
	{ name: 'CardName', title: 'BP Name' },
	{ name: 'AssignedTo', title: 'Assigned To' },
	{ name: 'StartDate', title: 'Activity Date' },
	{ name: 'SlpName', title: 'Sales Person' },
	{ name: 'Status', title: 'Status' },
	{ name: 'Type', title: 'Type' },
];



class ActivitySearch extends React.PureComponent {
	state = {
		values: {
			ClgCode: '',
			CardCode: '',
			CardName: '',
			Status: '',
			FromDate: '',
			ToDate: '',
			Type: '',
			AttendUser: '',
		},
		searching: false,
		rows: [],
		redirect: '',
	};


	componentDidMount = () => {
		if ( this.props.appData.UserID ) {
			let user = Number(this.props.appData.UserID);
			this.setState({ values: { ...this.state.values, AttendUser: user } });
		}
	};


	updateSearchVal = memoize(key => event => {
		this.setState({
			values: {
				...this.state.values,
				[ key ]: event.target.value,
			},
		});
	});


	updateDate = memoize(key => event => {
		let update = { ...this.state.values, [ key ]: event.target.value };

		if ( key === 'FromDate' && !update.ToDate ) {
			update.ToDate = event.target.value;
		}

		if ( key === 'ToDate' && !update.FromDate ) {
			update.FromDate = event.target.value;
		}

		this.setState({
			values: update,
		});
	});


	handleSearch = ( e ) => {
		e.preventDefault();
		this.setState({ searching: true, rows: [] });

		svc.send('activity', { method: 'search', ...this.state.values }).then(res => {
			this.setState({
				searching: false,
				rows: res.payload.data,
			});
		});
	};


	onRowSelect = ( sel ) => {
		if ( !sel.length ) {
			return false;
		}

		let row = this.state.rows[ sel[ 0 ] ];
		this.setState({ redirect: `/businesspartners/view/${row.CardCode}/activity/${row.ClgCode}` });
	};


	render() {
		const classes = this.props.classes;
		const tableClass = classnames(classes.searchTable, this.state.searching && 'automat-loading');
		let values = this.state.values;

		return (
			<div>
				<form onSubmit={this.handleSearch} className={classes.formField}>
					<Grid container className={classes.gridRoot} spacing={16}>

						<Grid item xs={12}>
							<Typography variant="h6">Activity Search</Typography>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="number"
								value={values.ClgCode}
								label="Activity Number"
								onChange={this.updateSearchVal('ClgCode')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="text"
								value={values.CardCode}
								label="BP Code"
								onChange={this.updateSearchVal('CardCode')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={2}>
							<TextField
								type="text"
								value={values.CardName}
								label="BP Name"
								onChange={this.updateSearchVal('CardName')}
								className={classes.formField}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Assigned To</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('AttendUser')}
									value={values.AttendUser}
									className={classes.formField}
								>
									<option value="" />
									{this.props.appData.Users.map(user => {
										return <option key={user.val} value={user.val}>{user.disp}</option>;
									})}
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="date"
								value={values.FromDate}
								label="Date Range - Start"
								onChange={this.updateSearchVal('FromDate')}
								onBlur={this.updateDate('FromDate')}
								className={classes.formField}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<TextField
								type="date"
								value={values.ToDate}
								label="Date Range - End"
								onChange={this.updateSearchVal('ToDate')}
								onBlur={this.updateDate('ToDate')}
								className={classes.formField}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Status</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('Status')}
									value={values.Status}
									className={classes.formField}
								>
									<option value="" />
									<option value="N">Open</option>
									<option value="Y">Closed</option>
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={3} lg={2} xl={1}>
							<FormControl className={classes.formField}>
								<InputLabel shrink>Type</InputLabel>
								<Select
									native
									input={<Input />}
									onChange={this.updateSearchVal('Type')}
									value={values.Type}
									className={classes.formField}
								>
									<option value="" />
									{this.props.appData.ActivityTypes.map(act => {
										return <option key={act.val} value={act.val}>{act.disp}</option>;
									})}
								</Select>
							</FormControl>
						</Grid>

						<Grid item xs={6} md={3} lg={3} xl={3}>
							<Button
								variant="contained"
								color="primary"
								className={classes.searchButton}
								onClick={this.handleSearch}
								disabled={this.state.searching}
								type={'submit'}
							>
								Search
							</Button>
						</Grid>

						<Grid item xs={12}>
							<Paper className={tableClass}>
								<SimpleTable
									columns={searchCols}
									rows={this.state.rows}
									onRowSelect={this.onRowSelect}
									defaultPageSize={15}
									cellComponent={ExpandableCell}
								/>
							</Paper>
						</Grid>

					</Grid>

					{
						this.state.redirect
						&& window.location.pathname !== this.state.redirect
						&& <Redirect to={this.state.redirect} push />
					}

				</form>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		appData: state.appData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setTitle: ( title ) => {
			dispatch(actions.layout.setTitle(title));
		},
	}
};

ActivitySearch = withStyles(styles)(ActivitySearch);
export default connect(mapStateToProps, mapDispatchToProps)(ActivitySearch);